import { render, staticRenderFns } from "./WidgetSetting.vue?vue&type=template&id=42a3a878&"
import script from "./WidgetSetting.vue?vue&type=script&lang=js&"
export * from "./WidgetSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports